import React from 'react';
import PropTypes from 'prop-types';

const SlowBackwardPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M23 4c-.553 0-1 .489-1 1.091v21.818c0 .603.447 1.091 1 1.091h2c.552 0 1-.488 1-1.091V5.091C26 4.489 25.552 4 25 4h-2zm-5.255.638L2.252 15.111a1.073 1.073 0 0 0 0 1.778l15.493 10.473A.804.804 0 0 0 19 26.695V5.305a.804.804 0 0 0-1.255-.667z"
    />
  );
};

SlowBackwardPath.propTypes = {
  fill: PropTypes.string,
};

export default SlowBackwardPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/media-playback/slow-backward.jsx